module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reservation"
  }, [_c('div', {
    staticClass: "h-header-bottom"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "dark",
      "default-active": _vm.activeIndex,
      "mode": "horizontal",
      "router": ""
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/home/reservation/Mrliu"
    }
  }, [_vm._v("今日预约")])], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42f8fe2f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/reservation/reservation.vue
// module id = 1014
// module chunks = 2